import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";
import get from "lodash/get";

import * as constants from "../../../constants";
import History from "./History";

const PAGINATION_INTERVAL = 25;
class ChangeHistory extends Component {
	constructor(props) {
		super(props);
		this.state = {
			history: [],
			showHistory: false,
			error: "",
			requestResolved: false,
			viewLength: PAGINATION_INTERVAL,
		};
	}

	hideHistoryContainer = () => {
		this.setState({
			showHistory: false,
			viewLength: PAGINATION_INTERVAL,
		});
	};

	showHistoryContainer = () => {
		this.setState({
			showHistory: true,
		});
	};

	loadHistory = () => {
		const { entity, id } = this.props;
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.get(`/${entity}/${id}/changes`)
					.then(res => {
						const { data } = res;
						this.setState({
							history: data,
							error: "",
							requestResolved: true,
						});
					})
					.catch(err => {
						const error = get(err, "response.data.Message");
						this.setState({
							error: error,
							requestResolved: true,
						});
					});
			});
	};

	showHistory = e => {
		e.preventDefault();
		this.loadHistory();
		this.showHistoryContainer();
	};

	seeMore = e => {
		e.preventDefault();
		const { history, viewLength } = this.state;
		if (!(viewLength > history.length)) {
			this.setState({
				viewLength: viewLength + PAGINATION_INTERVAL,
			});
		}
	};

	seeLess = e => {
		e.preventDefault();
		const { viewLength } = this.state;
		if (viewLength - PAGINATION_INTERVAL < PAGINATION_INTERVAL) {
			this.setState({
				viewLength: PAGINATION_INTERVAL,
			});
		} else {
			this.setState({
				viewLength: viewLength - PAGINATION_INTERVAL,
			});
		}
	};

	reset = () => {
		this.setState({
			history: [],
			showHistory: false,
			error: "",
			requestResolved: false,
			viewLength: PAGINATION_INTERVAL,
		});
	};

	render() {
		const { showHistory, history, error, requestResolved, viewLength } = this.state;
		return (
			<div className="change-history">
				<div className={`coverall ${showHistory ? "on" : "off"}`} onClick={this.hideHistoryContainer}></div>
				<button onClick={this.showHistory}>
					<i className="fal fa-history"></i>
				</button>
				<History
					visible={showHistory}
					history={history}
					requestResolved={requestResolved}
					error={error}
					reset={this.reset}
					length={viewLength}
					seeMore={this.seeMore}
					seeLess={this.seeLess}
					interval={PAGINATION_INTERVAL}
				/>
			</div>
		);
	}
}

ChangeHistory.propTypes = {
	entity: PropTypes.string,
	id: PropTypes.string,
};

export default ChangeHistory;
